<template>
    <div class="famous-pedia">
        <div class="famous-pedia-top-bar">
            <!-- 1. 搜索框 -->
            <div class="famous-pedia-title dsp-flex">
                <div class="famous-pedia-close" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </div>
                <div class="famous-pedia-search">
                    <search-input 
                        v-bind:inputId="searchInputId"
                        v-bind:searchData="searchData"
                        v-bind:inputFunc="inputSearch">
                    </search-input>
                </div>
                <div class="famous-pedia-search-button" @click.passive="clickSearch">
                    <span>搜索</span>
                </div>
                <!-- <div class="famous-pedia-side" @click.passive="clickFamousInform">
                    <div class="famous-pedia-note"><i class="iconfont icon-bell"></i></div>
                    <span class="famous-pedia-note-num" v-if="totalUnreadNumber != 0">
                        <span>{{totalUnreadNumber > 99 ? '...' : totalUnreadNumber}}</span>
                    </span>
                </div> -->
            </div>
            <!-- 2. 列表sub menu -->
            <div class="famous-sub-title-content">
                <div v-if="!showSearchResult" class="famous-sub-menu dsp-flex" v-bind:class="{'famous-sub-menu-sub':curPediaListData.length > 0 || searchPediaListData.length > 0}">
                    <div v-for="item in famousMenu" v-bind:key="item.id" @click.passive="clickMenu(item.id)" class="famous-sub-menu-item"><span v-bind:class="{'cur' : curPediaMenuId == item.id}">{{item.title}}</span></div>
                </div>
                <div v-else class="famous-sub-note">搜索到以下结果：</div>
            </div>
            <div class="layout-sub-ymd-title" v-if="(!showSearchResult && curPediaListData.length > 0) || (showSearchResult && searchPediaListData.length > 0)">
                <div class="layout-sub-ymd-title-box dsp-flex">
                    <div class="ymd-title-box-left"></div>
                    <div class="ymd-title-box" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                        <span class="title-span" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}"><span v-for="string in stringArr">{{string}}</span></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 3. 列表内容区域 -->
        <div v-if="!showSearchResult" class="famous-list">
            <!-- 默认列表 -->
            <famous-virtual-list
                v-bind:listData="curPediaListData"
                v-bind:gotData="curPediaListGot"
                v-bind:startCollateFunc="clickAddFast">
            </famous-virtual-list>
        </div>
        <div v-else class="famous-list">
            <!-- 搜索结果列表 -->
            <famous-virtual-list
                v-bind:listData="searchPediaListData"
                v-bind:gotData="true"
                v-bind:hideLoading="true">
            </famous-virtual-list>
        </div>
        <!-- 4. 新增百科入口 -->
        <div class="famous-add" @click.passive="clickAddFast">
            <div class="famous-add-btn"><i class="iconfont icon-plus-2"></i></div>
        </div>

        <router-view></router-view>
    </div>
</template>
<script>
import SearchInput from '../../components/SearchInput.vue'
import FamousVirtualList from '../../layouts/famouspedia/FamousVirtualList.vue'
import { FAMOUS_DOM } from '../../modules/dom';
import { MIX } from '../../modules/utils';
export default {
    name: 'FamousPedia',
    components: { SearchInput, FamousVirtualList },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        totalUnreadNumber() {
            return this.$store.state.inform.totalUnreadNumber;
        },
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        curPediaMenuId() {
            return this.$store.state.famouspedia.curPediaMenuId;
        },
        curPediaListGot() {
            return this.$store.state.famouspedia.curPediaListGot;
        },
        curPediaListData() {
            return this.$store.state.famouspedia.curPediaListData;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        searchPediaListData() {
            return this.$store.state.famouspedia.searchPediaListData;
        },
    },
    data() {
        return {
            searchInputId: 'pediaSearchInput',
            searchText: '',
            famousMenu: [
                {id: 1, title: '热门名人'},
                {id: 2, title: '最新创建'},
                {id: 3, title: '我的收藏'},
                {id: 4, title: '我的百科'},
                {id: 5, title: '最近浏览'},
            ],
            stringArr: ['年', '月', '日', '时'],
            showSearchResult: false
        }
    },
    mounted() {
        // 加载完成后,静默加载全部列表数据
        var me = this;
        this.$store.dispatch('initBasicData');
        this.$store.dispatch('inform/getConfigTips');
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
        this.$store.dispatch('famouspedia/initCurPediaList', {
            curId: this.curPediaMenuId,
            cb: function() {
                FAMOUS_DOM.updateFamouPediaList();
                setTimeout(() => {
                    me.initDom();
                }, 20);
            }
        });
        setTimeout(() => {
            MIX.trackPageViewed('BaiKe');
        }, 20);
    },
    methods: {
        initDom() {
            var listDom = document.getElementsByClassName('famous-list')[0],
                topBarDom = document.getElementsByClassName('famous-pedia-top-bar')[0],
                bottomDom = document.getElementsByClassName('bottom-menu-bar')[0];
            let height = innerHeight;
                height = bottomDom ? height - bottomDom.clientHeight : height;
            if(listDom) {
                listDom.style.height = height + 'px';
                if(topBarDom) {
                    listDom.style.paddingTop = topBarDom.clientHeight + 'px';
                }
            }
        },
        inputSearch(word) {
            this.searchText = word;
            if(word == '') {
                this.showSearchResult = false;
                this.$store.state.famouspedia.searchPediaListData.splice(0);
            }
        },
        clickBack() {
            this.$router.replace('/collate');
        },
        clickSearch() {
            var me = this;
            if(this.searchText != '') {
                this.$store.dispatch('famouspedia/getBaikeSearchResult', {
                    text: this.searchText,
                    cb: function(resultList) {
                        me.showSearchResult = resultList.length > 0 ? true : false;
                        if(resultList.length == 0) {
                            me.$toast('搜索不到该百科');
                        }
                    }
                });
            }else {
                this.$toast('请输入要搜索的关键词');
            }
        },
        clickFamousInform() {
            var me = this;
            this.$store.dispatch('inform/getMsgList', {
                cb: function() {
                    me.$router.replace('/famouspedia/inform');
                    FAMOUS_DOM.hideFamousPediaPage();
                }
            });
        },
        clickMenu(menuId) {
            switch(menuId) {
                case 1:
                    MIX.trackButtonClicked('home_baike_hot_tab');
                    break;
                case 2:
                    MIX.trackButtonClicked('home_baike_newest_tab');
                    break;
                case 3:
                    MIX.trackButtonClicked('home_baike_favorite_tab');
                    break;
                case 4:
                    MIX.trackButtonClicked('home_baike_mine_tab');
                    break;
                case 5:
                    MIX.trackButtonClicked('home_baike_viewed_tab');
                    break;
                default:
                    break;
            }
            this.$store.dispatch('famouspedia/initCurPediaList', {
                curId: menuId,
                cb: function() {
                    FAMOUS_DOM.updateFamouPediaList();
                }
            });
            this.$bus.emit('scrollFamousToTop');
        },
        clickAddFast() {
            this.$store.dispatch('allrecord/resetRecordData');
            this.$store.state.chooserecord.chooseFromPage = 'famouspedia';
            this.$store.state.chooserecord.chooseRecordType = 'single';
            this.$router.replace('/famouspedia/chooserecord')
        },
        clickStartCollate() {
            this.$store.dispatch('collate/resetData');
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/famouspediacreate');
        }
    }
}
</script>